import { ReactNode } from 'react';

import { Price } from '@bytel/trilogy-react-ts';

import { Connectivity, PlanType } from '@app-types/product';

type RadioStatus = {
    fourGRadio: {
        valid: boolean;
        description: ReactNode;
        invisibleDescription?: boolean;
    };
    fiveGRadio: {
        valid: boolean;
        description: ReactNode;
        invisibleDescription?: boolean;
    };
};

export function getRadioLabels(selectedProduct: PlanType, selectedNetwork: Connectivity): RadioStatus {
    if (!selectedProduct.option5g?.gencode) {
        return {
            fourGRadio: { valid: false, description: 'incluse', invisibleDescription: true },
            fiveGRadio: { valid: true, description: 'incluse' },
        };
    }

    const option5gPrice = selectedProduct.option5g.price ?? 0;
    const isFourGSelected = selectedNetwork === Connectivity.FOUR_G;

    const formatPriceLabel = (price: number, isPositive: boolean = true): ReactNode => {
        if (price === 0) return 'incluse';
        const sign = isPositive ? '+' : '-';
        return (
            <>
                {sign}
                <Price inline period='mois' amount={price} className='normal-weight' />
            </>
        );
    };

    return {
        fourGRadio: {
            valid: true,
            description: isFourGSelected ? 'incluse' : formatPriceLabel(option5gPrice, false),
        },
        fiveGRadio: {
            valid: true,
            description: isFourGSelected ? formatPriceLabel(option5gPrice) : 'incluse',
            invisibleDescription: !isFourGSelected,
        },
    };
}
export default getRadioLabels;
